module.exports = __webpack_public_path__ + "img/allinone_pay_logo.023e5186.svg";